/** 确保画板 GeoJSON source / 线面点 / 预览图层存在（切底图后可重建） */
import {
  SOURCE_ID,
  LINE_LAYER,
  FILL_LAYER,
  POINT_LAYER,
  PREVIEW_SOURCE,
  PREVIEW_LINE_SOURCE,
  PREVIEW_LINE,
  PREVIEW_FILL,
  PREVIEW_POINTS,
  DRAFT_LINE_COLOR
} from './constants';

export function ensureDrawLayers(map) {
  if (!map || typeof map.getStyle !== 'function') return false;

  const layersAlive = !!(
    map.getSource?.(PREVIEW_SOURCE)
    && map.getSource?.(PREVIEW_LINE_SOURCE)
    && map.getLayer?.(PREVIEW_LINE)
  );

  let styleJsonReady = false;
  try {
    const style = map.getStyle();
    styleJsonReady = !!(style && Array.isArray(style.layers));
  } catch (_) {
    styleJsonReady = false;
  }
  let fullyLoaded = false;
  try {
    fullyLoaded = typeof map.isStyleLoaded === 'function' && map.isStyleLoaded();
  } catch (_) {
    fullyLoaded = false;
  }

  if (!fullyLoaded && !styleJsonReady) {
    return layersAlive;
  }
  if (!fullyLoaded && layersAlive) {
    return true;
  }

  try {
    if (!map.getSource(SOURCE_ID)) {
      map.addSource(SOURCE_ID, {
        type: 'geojson',
        data: { type: 'FeatureCollection', features: [] }
      });
    }
    if (!map.getLayer(FILL_LAYER)) {
      map.addLayer({
        id: FILL_LAYER,
        type: 'fill',
        source: SOURCE_ID,
        filter: ['all', ['==', '$type', 'Polygon'], ['==', 'fill', true]],
        paint: {
          'fill-color': ['coalesce', ['get', 'color'], '#1976d2'],
          'fill-opacity': [
            '*',
            ['case', ['has', 'opacity'], ['get', 'opacity'], 0.85],
            0.35
          ]
        }
      });
    }
    if (!map.getLayer(LINE_LAYER)) {
      map.addLayer({
        id: LINE_LAYER,
        type: 'line',
        source: SOURCE_ID,
        filter: ['==', '$type', 'LineString'],
        layout: {
          'line-cap': 'round',
          'line-join': 'round'
        },
        paint: {
          'line-color': ['coalesce', ['get', 'color'], '#1976d2'],
          'line-width': ['coalesce', ['get', 'lineWidth'], 3.5],
          'line-opacity': ['coalesce', ['get', 'opacity'], 0.85]
        }
      });
    } else {
      try {
        map.setPaintProperty(LINE_LAYER, 'line-width', ['coalesce', ['get', 'lineWidth'], 3.5]);
        map.setLayoutProperty(LINE_LAYER, 'line-cap', 'round');
        map.setLayoutProperty(LINE_LAYER, 'line-join', 'round');
      } catch (_) { /* ignore */ }
    }
    if (!map.getLayer(POINT_LAYER)) {
      map.addLayer({
        id: POINT_LAYER,
        type: 'circle',
        source: SOURCE_ID,
        filter: [
          'all',
          ['==', '$type', 'Point'],
          ['!=', 'kind', 'text']
        ],
        paint: {
          'circle-radius': 6,
          'circle-color': ['coalesce', ['get', 'color'], '#1976d2'],
          'circle-stroke-width': 1.5,
          'circle-stroke-color': '#fff'
        }
      });
    }

    if (!map.getSource(PREVIEW_SOURCE)) {
      map.addSource(PREVIEW_SOURCE, {
        type: 'geojson',
        data: { type: 'FeatureCollection', features: [] }
      });
    }
    if (!map.getSource(PREVIEW_LINE_SOURCE)) {
      map.addSource(PREVIEW_LINE_SOURCE, {
        type: 'geojson',
        data: { type: 'FeatureCollection', features: [] }
      });
    }
    if (!map.__zhxtPreviewLineV2) {
      map.__zhxtPreviewLineV2 = true;
      if (map.getLayer(PREVIEW_LINE)) {
        try { map.removeLayer(PREVIEW_LINE); } catch (_) { /* ignore */ }
      }
    }
    if (!map.getLayer(PREVIEW_FILL)) {
      map.addLayer({
        id: PREVIEW_FILL,
        type: 'fill',
        source: PREVIEW_SOURCE,
        filter: ['==', '$type', 'Polygon'],
        paint: {
          'fill-color': DRAFT_LINE_COLOR,
          'fill-opacity': 0.2
        }
      });
    }
    if (!map.getLayer(PREVIEW_LINE)) {
      map.addLayer({
        id: PREVIEW_LINE,
        type: 'line',
        source: PREVIEW_LINE_SOURCE,
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
          visibility: 'visible'
        },
        paint: {
          'line-color': DRAFT_LINE_COLOR,
          'line-width': 4,
          'line-opacity': 1
        }
      });
    }
    if (!map.getLayer(PREVIEW_POINTS)) {
      map.addLayer({
        id: PREVIEW_POINTS,
        type: 'circle',
        source: PREVIEW_SOURCE,
        filter: ['==', '$type', 'Point'],
        paint: {
          'circle-radius': 6.5,
          'circle-color': DRAFT_LINE_COLOR,
          'circle-stroke-width': 1.5,
          'circle-stroke-color': '#fff'
        }
      });
    }
    try {
      if (map.getLayer(PREVIEW_LINE)) map.moveLayer(PREVIEW_LINE);
      if (map.getLayer(PREVIEW_POINTS)) map.moveLayer(PREVIEW_POINTS);
    } catch (_) { /* ignore */ }
    return true;
  } catch (err) {
    console.warn('画板图层尚未就绪，稍后重试:', err?.message || err);
    return false;
  }
}
